import { QueryKeysEnum } from '@/enums';
import {
  CreateDonorProfile,
  DonorFmtEntity,
  UpdateDonorProfile,
} from '@/types';
import { BaseService } from './base.service';
import APIService from './axios.service';

class FmtDonorService extends BaseService<
  'donor',
  DonorFmtEntity,
  CreateDonorProfile
> {
  constructor() {
    super(QueryKeysEnum.FMT_DONOR);
  }

  updateDonor = (payload: {
    id: string;
    data: UpdateDonorProfile;
  }): Promise<DonorFmtEntity> => {
    const { id, data } = payload;
    return APIService.patch(this.path + '/' + id, data);
  };

  suggestProfileId = (): Promise<string> => {
    return APIService.get(this.path + '/suggested-profile-id');
  };
}

export const fmtDonorService = new FmtDonorService();
